// extracted by mini-css-extract-plugin
module.exports = {"moduleSettingsErrorTab":"EditUser_moduleSettingsErrorTab__1u0Vw","accountTabs":"EditUser_accountTabs__1y_M0"};